import {initWebComponent} from "@/helpers/web-component-helper";
import {setInfoValue} from "@/helpers/info-overview-helper";

const template = document.createElement('template');

export class FormTextComponent extends HTMLElement {
    constructor() {
        super();
        const name = this.getAttribute('data-name')
        const placeholder = this.getAttribute('data-placeholder')
        const defaultValue = this.getAttribute('data-default-value')
        const attributeID = this.getAttribute('data-attribute-id')
        const isRequired = this.getAttribute('data-is-required')

        let innerHTML = `
                          <div class="row">
                                <div class="col">
                                    <div class="form-group text-primary mb-4">
                                        <h2 class="text-primary">${name}${isRequired}</h2>
                                        <input type="text" class="form-control" placeholder="` + placeholder + `" value="` + defaultValue + `">`

        if(isRequired) {
            innerHTML += `              <small class="invalid-feedback">
                                            Dit veld is verplicht
                                        </small>`
        }

        innerHTML += `   
                                    </div>
                                </div>
                          </div>`

        template.innerHTML = innerHTML

        initWebComponent(this, template)

        this.addEventListener('change', (element) => {
            const innerHtml = element.target.value
            setInfoValue(attributeID, innerHtml)
        })
    }
}
